import firebase from "@firebase/app";
import "@firebase/auth";
import "@firebase/firestore";
import "@firebase/storage";

const config = {
    apiKey: "AIzaSyA27e8EsAE1uAI_3vODNiHJ0twKmS_kkio",
    authDomain: "translate-9f047.firebaseapp.com",
    databaseURL: "https://translate-9f047.firebaseio.com",
    projectId: "translate-9f047",
    storageBucket: "",
    messagingSenderId: "1049730343834",
    appId: "1:1049730343834:web:6f2bcc0ec165c717abd023"
};

export default {
    init() {
        firebase.initializeApp(config);
        firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);
    }
}